export default __webpack_public_path__ + "static/media/topcharacter7.1b24f6ca.jpeg";